import React from 'react';

export default ({ color }) => <div className={`spinner-border text-${color ?? "primary"}`} role="status"><span className="sr-only">Loading...</span></div>

export const growingSpinner = ({ color }) => <div className={`spinner-grow text-${color ?? "primary"}`} role="status"><span className="sr-only">Loading...</span></div>

export const center = ({ children }) => <div className="d-flex align-items-center">{children}</div>

export const LoadingButton = ({ children }) => <button className="btn btn-primary" type="button" disabled>{children} <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>;